import MenuItemComponent from "./menu-item";

function MenuItem({
  id,
  selectedSubMenu,
  menuItemTitle,
  link,
  subMenuOptions,
  onSelectManeuItem,
}) {
  return (
    <MenuItemComponent
      id={id}
      isSubMenuOpen={id === selectedSubMenu}
      menuItemTitle={menuItemTitle}
      link={link}
      subMenuOptions={subMenuOptions}
      onSelectManeuItem={onSelectManeuItem}
    />
  );
}

export default MenuItem;
